// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { deleteNotifications } from '../../../apis/member'
import { deleteNotificationsActions } from '../../actionCreators/notifications/deleteNotificationsActions';
import { RootAction } from '../../rootActionCreator';

const outputActions = {
  success: deleteNotificationsActions.success,
  failure: deleteNotificationsActions.failure
};

type RequestActionTypes = ActionType<typeof deleteNotificationsActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const deleteNotificationsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(deleteNotificationsActions.request)
    ),
    switchMap(async (action: RequestActionTypes) => {
      const {
        ids,
        success
      } = action.payload;
      console.log(ids);
      return deleteNotifications(ids)
        .then(() => {
          success();
          return outputActions.success({});
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return outputActions.failure({ error });
        });
    })
  );
};
